/**
 * APH meal plan (Harry 2026-09-23). Harry's cutting day as the template,
 * grams scaled so totals track the person's calculated numbers.
 * APH whey in every protein slot. No sauerkraut. Normal dashes, no em dashes.
 * Shared by /pages/macro-calculator (results) and /pages/meal-planner.
 */
window.APHMealPlan = (function () {
  /* Baseline day ~2,310 kcal. fixed = countable items that do not scale. */
  var BASE_CAL = 2311;
  var MEALS = [
    {
      name: 'Breakfast / pre-workout',
      items: [
        { n: 'Oats', g: 80, kcal: 304, p: 11, c: 54, f: 6 },
        { n: 'Water (to mix)', g: 0, kcal: 0, p: 0, c: 0, f: 0, fixed: true },
        { n: 'APH whey protein - 1 scoop', g: 30, kcal: 120, p: 24, c: 2, f: 2, fixed: true },
        { n: 'Raspberries', g: 100, kcal: 52, p: 1, c: 12, f: 0.5 },
        { n: 'Honey', g: 15, kcal: 46, p: 0, c: 12, f: 0 },
      ],
    },
    {
      name: 'Post-gym',
      items: [
        { n: 'Chocolate rice cakes - 4', g: 40, kcal: 160, p: 2, c: 32, f: 3, fixed: true },
        { n: 'Honey', g: 15, kcal: 46, p: 0, c: 12, f: 0 },
      ],
    },
    {
      name: 'Lunch',
      items: [
        { n: 'Bacon - 3 rashers', g: 90, kcal: 240, p: 18, c: 0, f: 19, fixed: true },
        { n: 'Eggs - 2', g: 100, kcal: 140, p: 12, c: 1, f: 10, fixed: true },
        { n: 'Toast - 2 slices', g: 60, kcal: 160, p: 6, c: 30, f: 2 },
      ],
    },
    {
      name: 'Snack',
      items: [
        { n: 'Greek yogurt', g: 200, kcal: 120, p: 18, c: 7, f: 2 },
        { n: 'APH whey protein - 1 scoop', g: 30, kcal: 120, p: 24, c: 2, f: 2, fixed: true },
        { n: 'Raspberries', g: 100, kcal: 52, p: 1, c: 12, f: 0.5 },
        { n: 'Honey', g: 15, kcal: 46, p: 0, c: 12, f: 0 },
      ],
    },
    {
      name: 'Dinner',
      items: [
        { n: 'Chicken breast', g: 200, kcal: 330, p: 46, c: 0, f: 15 },
        { n: "Ben's rice - 250g pouch", g: 250, kcal: 325, p: 7, c: 66, f: 1, fixed: true, pouch: true },
        { n: 'Veg', g: 150, kcal: 50, p: 3, c: 9, f: 1 },
      ],
    },
  ];

  function round5(x) {
    return Math.max(5, Math.round(x / 5) * 5);
  }

  function scaledItems(targetCal) {
    var r = Math.max(0.5, Math.min(2.2, targetCal / BASE_CAL));
    return MEALS.map(function (meal) {
      var items = meal.items.map(function (it) {
        if (it.fixed || !it.g) {
          return { n: it.n, g: it.g, kcal: it.kcal, p: it.p, c: it.c, f: it.f, scaled: false, pouch: !!it.pouch };
        }
        var g = round5(it.g * r);
        var k = g / it.g;
        return {
          n: it.n,
          g: g,
          kcal: Math.round(it.kcal * k),
          p: Math.round(it.p * k),
          c: Math.round(it.c * k),
          f: Math.round(it.f * k),
          scaled: true,
          pouch: !!it.pouch,
        };
      });
      return { name: meal.name, items: items };
    });
  }

  function totals(meals) {
    var t = { kcal: 0, p: 0, c: 0, f: 0 };
    meals.forEach(function (m) {
      m.items.forEach(function (it) {
        t.kcal += it.kcal;
        t.p += it.p;
        t.c += it.c;
        t.f += it.f;
      });
    });
    return t;
  }

  function mealTotals(meal) {
    var t = { kcal: 0, p: 0, c: 0, f: 0 };
    meal.items.forEach(function (it) {
      t.kcal += it.kcal;
      t.p += it.p;
      t.c += it.c;
      t.f += it.f;
    });
    return t;
  }

  function shoppingList(meals) {
    /* Unique items, grams combined across meals, sorted A-Z (Harry macro-tight).
       Countable items (scoops/rashers/eggs/pouch) keep their pack label as-is. */
    var map = {};
    meals.forEach(function (m) {
      m.items.forEach(function (it) {
        if (!it.g && !/scoop|rashers|eggs|rice cakes/i.test(it.n)) return;
        if (!map[it.n]) map[it.n] = { n: it.n, g: 0 };
        map[it.n].g += it.g || 0;
      });
    });
    return Object.keys(map)
      .sort(function (a, b) {
        return a.localeCompare(b);
      })
      .map(function (k) {
        var it = map[k];
        if (/rashers|slices|scoop|eggs|rice cakes|pouch/i.test(it.n)) return it.n;
        return it.n + ' - ' + it.g + 'g';
      });
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  /**
   * Render the plan into container.
   * targets: { cal, protein, carbs, fat } from the calculator.
   * opts: { logoUrl, wheyImg }
   * Visual meal cards - icons + APH whey packshot + rice pouch graphic.
   * No AI/stock food photos. No PDF button (email send lives in the section).
   */
  var MEAL_ICONS = {
    'Breakfast / pre-workout':
      '<svg viewBox="0 0 256 256" aria-hidden="true"><circle cx="128" cy="128" r="60" fill="none" stroke="currentColor" stroke-width="16"/><path d="M128,36V20M128,236V220M36,128H20M236,128H220M64,64l-12-12M204,204l-12-12M64,192l-12,12M204,52l-12,12" fill="none" stroke="currentColor" stroke-width="16" stroke-linecap="round"/></svg>',
    'Post-gym':
      '<svg viewBox="0 0 256 256" aria-hidden="true"><path d="M136,32,49.72,144.58A8,8,0,0,0,56,157.66h64.4a8,8,0,0,1,7.79,9.9L112,224l86.28-112.58a8,8,0,0,0-6.28-13.08h-64.4a8,8,0,0,1-7.79-9.9Z" fill="none" stroke="currentColor" stroke-width="16" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    Lunch:
      '<svg viewBox="0 0 256 256" aria-hidden="true"><path d="M32,112H224a0,0,0,0,1,0,0v8a96,96,0,0,1-96,96h0a96,96,0,0,1-96-96v-8A0,0,0,0,1,32,112Z" fill="none" stroke="currentColor" stroke-width="16"/><path d="M64,88a64,64,0,0,1,128,0" fill="none" stroke="currentColor" stroke-width="16"/></svg>',
    Snack:
      '<svg viewBox="0 0 256 256" aria-hidden="true"><path d="M200,80H56a0,0,0,0,1,0,0V200a24,24,0,0,0,24,24h96a24,24,0,0,0,24-24V80A0,0,0,0,1,200,80Z" fill="none" stroke="currentColor" stroke-width="16"/><path d="M72,80V64a56,56,0,0,1,112,0V80" fill="none" stroke="currentColor" stroke-width="16"/></svg>',
    Dinner:
      '<svg viewBox="0 0 256 256" aria-hidden="true"><path d="M216,112A88,88,0,1,1,128,24a88.1,88.1,0,0,1,88,88Z" fill="none" stroke="currentColor" stroke-width="16"/><path d="M128,48a80,80,0,0,1,80,80" fill="none" stroke="currentColor" stroke-width="16" stroke-linecap="round"/></svg>',
  };

  function render(container, targets, opts) {
    if (!container) return;
    opts = opts || {};
    var meals = scaledItems(targets.cal || BASE_CAL);
    var t = totals(meals);
    var shop = shoppingList(meals);

    var html = '';
    html += '<div class="aph-meal-plan-sheet">';
    if (opts.logoUrl) {
      html += '<div class="aph-meal-plan-printhead"><img src="' + esc(opts.logoUrl) + '" alt="APH Science" width="120" height="32"><h3>Here\'s your meal plan</h3></div>';
    }
    html += '<h3 class="aph-meal-plan-title">Here\'s your meal plan</h3>';
    html += '<p class="aph-meal-plan-sub">Built around your numbers - Calories ' + (targets.cal || t.kcal) + ' · Protein ' + (targets.protein || t.p) + 'g · Carbs ' + (targets.carbs || t.c) + 'g · Fat ' + (targets.fat || t.f) + 'g</p>';

    html += '<div class="aph-meal-grid">';
    meals.forEach(function (m) {
      var mt = mealTotals(m);
      var hasWhey = m.items.some(function (it) {
        return /whey/i.test(it.n);
      });
      var hasRice = m.items.some(function (it) {
        return it.pouch;
      });
      html += '<div class="aph-meal-card">';
      html += '<div class="aph-meal-card-head">';
      if (hasWhey && opts.wheyImg) {
        html += '<span class="aph-meal-card-media"><img src="' + esc(opts.wheyImg) + '" alt="APH whey protein" loading="lazy"></span>';
      } else if (hasRice) {
        html += '<span class="aph-meal-card-media aph-rice-pouch"><span class="aph-rice-pouch-label">Ben\'s<br>Rice</span><span class="aph-rice-pouch-size">250g</span></span>';
      } else {
        html += '<span class="aph-meal-card-media aph-meal-card-icon">' + (MEAL_ICONS[m.name] || MEAL_ICONS.Lunch) + '</span>';
      }
      html += '<h4>' + esc(m.name) + '</h4>';
      html += '</div>';
      html += '<ul class="aph-meal-chips">';
      m.items.forEach(function (it) {
        var grams = it.g > 0 ? it.g + 'g' : '';
        html += '<li><span>' + esc(it.n) + '</span>' + (grams ? '<b>' + grams + '</b>' : '') + '</li>';
      });
      html += '</ul>';
      html += '<p class="aph-meal-macros">Meal - ' + mt.kcal + ' kcal · P ' + mt.p + 'g · C ' + mt.c + 'g · F ' + mt.f + 'g</p>';
      html += '</div>';
    });
    html += '</div>';

    html += '<div class="aph-meal-plan-totals">';
    html += '<strong>Day totals</strong>';
    html += '<span>Calories - ' + t.kcal + '</span>';
    html += '<span>Protein - ' + t.p + 'g</span>';
    html += '<span>Carbs - ' + t.c + 'g</span>';
    html += '<span>Fat - ' + t.f + 'g</span>';
    html += '</div>';

    html += '<details class="aph-meal-plan-shop" open>';
    html += '<summary>Shopping list</summary>';
    html += '<ul class="aph-meal-plan-shop-list">';
    shop.forEach(function (label, i) {
      html += '<li><label><input type="checkbox"> <span>' + esc(label) + '</span></label></li>';
    });
    html += '</ul>';
    html += '</details>';

    html += '</div>';

    container.innerHTML = html;
    container.hidden = false;
  }

  return { render: render };
})();
